import HttpRequest from '@/plugin/axios/index';

export default {
  axios_spAdmin: new HttpRequest(`${process.env.VUE_APP_SP_HOST}`),
  axios_admin: new HttpRequest(`${process.env.VUE_APP_HOST}`),
  axios_mock: new HttpRequest(`${process.env.VUE_APP_LOG_HOST}`),
  axios_node: new HttpRequest(
    `${process.env.VUE_APP_NODE_BACKEND_HOST || 'https://node.coding4fun.com.cn'}`,
  ),
};
